import script from "./AIExampleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AIExampleModal.vue?vue&type=script&setup=true&lang=js"

import "./AIExampleModal.vue?vue&type=style&index=0&id=43e0a4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e0a4fa"]])

export default __exports__